
















































































































































































import IListStatusInbound from '@/store/models/IListStatusInbound';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: { Snackbar }
})
export default class ListStatusInboundsSelector extends Vue {
  searchListStatusInbounds = "";
  dialog = false;
  isValid = true;
  sortBy = 'name';
  sortDesc = false;

  headers: any = [
      { text: 'Name', value: 'name' },
      { text: 'Color', value: 'color' },
      { text: 'Actions', value: 'actions', sortable: false }
  ];

  editedIndex = -1;
  editedItem: IListStatusInbound = { id: "", name: "", isFinished: false, color: "", idCompany: "" };
  defaultItem: IListStatusInbound = { id: "", name: "", isFinished: false, color: "", idCompany: "" };

  @Prop({ type: Array, required: true }) ListStatusInboundsList!: IListStatusInbound[];
  @Prop({ type: Array, required: true }) Permissions!: IRolePermission[];

  selectedListStatusInbounds: IListStatusInbound[] = [];

  availableColors: string[] = [
      'red', 'green', 'blue', 'orange', 'purple', 'cyan', 'teal', 'pink', 'grey', 'brown'
  ];

  get formTitle() {
      return this.editedIndex === -1 ? 'New Inbound Status' : 'Edit Inbound Status';
  }

  @Watch('dialog')
  onDialogChanged(val: any) {
      val || this.close();
  }

  resetListStatusInbounds() {
      this.selectedListStatusInbounds = [];
  }

  editListStatusInbound(item: any) {
      this.editedIndex = this.ListStatusInboundsList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
  }

  saveListStatusInbound() {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
          if (this.editedIndex > -1 || this.selectedListStatusInbounds[0]) {
              this.close();
              this.$emit('editListStatusInbound', this.editedItem);
              Object.assign(this.ListStatusInboundsList[this.editedIndex], this.editedItem);
          } else {
              this.selectedListStatusInbounds[0] = this.editedItem;
              this.$emit('saveListStatusInbound', this.editedItem);
          }
          this.close();
      } else {
          this.$emit('showMessageWarning', 'All required fields must be filled out');
      }
  }

  deleteListStatusInbound(statusInbound: IListStatusInbound) {
      this.$emit('deleteListStatusInbound', statusInbound);
      this.close();
  }

  close() {
      this.dialog = false;
      this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
      });
  }

  selectListStatusInbounds(item: any) {
      if (!this.selectedListStatusInbounds.includes(item)) {
          this.selectedListStatusInbounds = [item];
      } else {
          this.selectedListStatusInbounds = [];
      }
  }

  showMessageInfo(message: string) {
      (this.$refs.snackbar as Snackbar).showInfo(message);
  }
  showMessageError(message: string) {
      (this.$refs.snackbar as Snackbar).showError(message);
  }
  showMessageWarning(message: string) {
      (this.$refs.snackbar as Snackbar).showWarning(message);
  }
}
